import { summariesQueryKey, toApiConfig } from '~/business-logic/relationshipSummaryScope';
import { useStore, useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_PROPOSALS = [];
export const useProposals = function useProposals() {
    let { refreshOnHookMount = false, withLoader = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const enabled = !!businessId;
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: summariesQueryKey({
            kind: 'proposals'
        }, {
            businessId,
            isVendor
        }),
        queryFn: ()=>api.relationship.getSummaries(toApiConfig({
                kind: 'proposals'
            }, {
                businessId: businessId,
                isVendor
            })),
        enabled,
        refreshOnHookMount,
        withLoader
    });
    return {
        proposals: data !== null && data !== void 0 ? data : EMPTY_PROPOSALS,
        isLoading: isLoading || !enabled,
        isFetching,
        refresh,
        error
    };
};
